import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faCopy } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useItemAnalysisContext } from '../utils/itemAnalysisContext';
import { useNavigate } from 'react-router';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import ProgressButton from '../../../../../components/ProgressButton';

const ItemAnalysisHeader = ({
  isExporting,
  isPageLoading,
  exportHandler,
  isPdfGenerating,
  printHandler,
  handleCopyToClipboard
}) => {
  const {primaryAssignmentName} = useItemAnalysisContext();
  const navigate = useNavigate();
  const backToFilter = ()=>{   
    navigate('/reports/item-analysis');
  };

  return (
    <>
      <Row className="d-flex justify-content-between">
        <Col>
          <h5>Item Analysis Report: {primaryAssignmentName}</h5>
        </Col>
        <Col id="buttonGroup" className="justify-content-end col-6 ReportToolbarBtn gap-3 align-items-center">
          <div disabled={isPageLoading} onClick={handleCopyToClipboard}
            className={`clr-castleRed mr-2 fs-14 ${!isPageLoading? 'cursor-pointer':''}`}>
            <FontAwesomeIcon icon={faCopy} /> Copy to Clipboard
            <OverlayTrigger
              key="label-info"
              placement="top"
              overlay={
                <Tooltip id="parent-tooltip" className="image-info-tooltip">
                  <div>Copy to Clipboard does not work with very large data sets. Use Export or Print to PDF instead</div>
                </Tooltip>
              }>
              <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
            </OverlayTrigger>
          </div>
          <button id="export_button" disabled={isExporting || isPageLoading} onClick={exportHandler} className="btn btn-width btn-castleWhite p-0">
            {isExporting ? 'Exporting...' : 'Export'}
          </button>
          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={printHandler}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleOrange p-0"
            disabled={isPageLoading}
          />
          <button disabled={isPageLoading} onClick={backToFilter} id="new_Report" className="btn btn-castleRed btn-width">
            New Report
          </button>
        </Col>
      </Row>
    </>
  );
};

ItemAnalysisHeader.propTypes = {
  exportHandler: PropTypes.func,
  printHandler: PropTypes.func,
  isExporting: PropTypes.bool,
  isPdfGenerating: PropTypes.bool,
  isPageLoading: PropTypes.bool,
  handleCopyToClipboard: PropTypes.func
};

export default ItemAnalysisHeader;